import styled from "styled-components";

export const HomeHeroContainer = styled.div``;
